// import Data from "../../data/hiring_organizations.json";

import ComparisonWithOtherTable from "./ComparisonWithOtherTable";

function ComparisonWithOther() {
  return (
    <div className="comparison-with-other my-3 container text-center px-4">
      <div className="row mt-4 px-1 justify-content-center">
        <h2 className="faq-heading fs-6 fw-bold px-4 py-2 rounded section-tag text-center">
          8. Why Logicmojo ?
          </h2>
        
        
      </div>
      <ComparisonWithOtherTable />
    </div>
  );
}
export default ComparisonWithOther;
